import { combineReducers } from 'redux'
import {cartReducer} from "./cart_reducer";
import {userReducer} from "./user_reducer";
import {orderReducer} from "./order_reducer";
import {catalogReducer} from "./catalog_reducer";

export const rootReducer = combineReducers({
    cart: cartReducer,
    user: userReducer,
    order: orderReducer,
    catalog: catalogReducer,
});
